import { useState } from "react";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import ContactUsButton from "./contact-us-button";
import { useTranslation } from "react-i18next";

export default function OurServices(props){

    const [opened, setOpened] = useState("");
        const { t } = useTranslation();
    const values=[ {
    "title": "Acheter",
    "img": "Acheter.jpeg.jpg",
    "text": "Acheter des biens immobiliers chez LM Platinum Estates c’est choisir des biens titrés et vérifiés auprès des autorités compétentes. Achetez vos terrains, maisons, immeubles et autres biens immobiliers en un seul clic. Nos offres sont disponibles à Yaoundé, Douala et Kribi principalement mais aussi dans d’autres villes du Cameroun. Consultez notre catalogue de terrains et maisons à vendre."
  },
  {
    "title": "Louer",
    "img": "Louer.jpeg.jpg",
    "text": "Nous mettons à votre disposition des biens de qualité à des prix compétitifs. Nos conditions de travail sont claires, des contrats de location transparents pour éviter des abus en tout genre. Vous recherchez une maison à louer, un appartement à louer, une boutique ou autres biens à louer. Consultez notre catalogue de biens immobiliers à louer."
  },
  {
    "title": "Construction",
    "img": "construire.jpeg.jpg",
    "text": "Notre équipe d’expert en BTP se tient à vos dispositions pour la réalisation de vos projets de construction clés en main. Notre objectif des biens solides et agréable à vivre. Nos compétences : - Programmation et étude de faisabilité - Élaboration des plans et conception schématique - Documents contractuels - Construction"
  },
  {
    "title": "Gestion locative",
    "img": "Gestionlocative.jpeg.jpg",
    "text": "Bénéficiez d’une équipe d’agent immobiliers expérimentés constituée de propriétaires qui comprennent vos attentes et vos besoins. Nous vous accompagnons de la recherche du locataire et la gestion complète de votre bien. Nous vous déchargeons de tout ! Notre offre de gestion locative comprend : - La recherche du locataire idéal - Gestion administrative - Rédaction des contrats et gestion des contrats - Communication avec les locataires - Entretien et réparation - Rapports financiers Une gestion rigoureuse et transparente, un suivi sans faille. Votre bien est entretenu au fil du temps avec des locataires responsables. Un revenu locatif perçu dans les temps."
  },
  {
    "title": "Vendre ou Louer Son Bien Immobilier",
    "img": "Vendreimmobilier.jpeg.jpg",
    "text": "« Vous souhaitez vendre ou louer votre bien rapidement et au meilleur prix ? » Nous mettons à votre disposition : - Une estimation gratuite de votre bien - Nettoyage et embellissement du bien - Photos et vidéos de qualité de votre bien - Suivi et compte rendu - Délai de vente court - Rédaction des contrats de vente Vous avez le bien et nous avons le client."
  },
  {
    "title": "Topografie",
    "img": "topographie.jpeg.jpg",
    "text": "Services fournis par LM Platinum Estates incluent : - Bornage - Terrassement - Conception et plan topographique - Urbanisme - Tirage et plan topo - Location de matériel topo - Immatriculation Vous avez les terres mais pas les moyens de le faire immatriculer LM Platinum Estates se porte garant de tout. Nous finançons votre projet de A à Z. Autres services : - Lotissement - Morcellement"
  }
];

    function setOpenedBlock(name){
        if(opened == name) setOpened("");
        else
            setOpened(name);
    }

    return <>
        {/* <div id="our-services">
            <div>
                <div id="title">
                    {values[0].title}
                </div>
                <div id="text">                    
                    {values[0].text}
                </div>
                <div id="image">
                    <img src="5379637510122105177.jpg"/>
                </div>
            </div>
            {!isMobile ? 
            <div>                
                <div id="image">
                    <img src="5379637510122105178.jpg"/>
                </div>
                <div id="title">
                    {values[1].title}
                </div>
                <div id="text">                    
                    {values[1].text}
                </div>
            </div>
            :
            <div>       
                <div id="title">
                    {values[1].title}
                </div>
                <div id="text">        
                    {values[1].text}   
                </div>         
                <div id="image">
                    <img src="5379637510122105178.jpg"/>
                </div>
            </div>
            }
            <div>        
                <div id="title">
                    {values[2].title}
                </div>
                <div id="text">                    
                    {values[2].text}
                </div>        
                <div id="image">
                    <img src="5379637510122105174.jpg"/>
                </div>
            </div>
        </div>
        <div id="our-services">
            <div>
                <div id="title">
                    {values[3].title}
                </div>
                <div id="text">                    
                    {values[3].text}
                </div>
                <div id="image">
                    <img src="5379637510122105176.jpg"/>
                </div>
            </div>
            {!isMobile ? 
            <div>                
                <div id="image">
                    <img src="terrain_default.jpg"/>
                </div>
                <div id="title">
                    {values[4].title}
                </div>
                <div id="text">                    
                    {values[4].text}
                </div>
            </div>
            :
            <div>       
                <div id="title">
                    {values[4].title}
                </div>
                <div id="text">        
                    {values[4].text}   
                </div>         
                <div id="image">
                    <img src="terrain_default.jpg"/>
                </div>
            </div>
            }
            <div>        
                <div id="title">
                    {values[5].title}
                </div>
                <div id="text">                    
                    {values[5].text}
                </div>        
                <div id="image">
                    <img src="5379637510122105179.jpg"/>
                </div>
            </div>
        </div> */}
        <div id='services-block' className="main-content-block-long blue-rounded-border">
            <div id='title'>{t('À propos de nous')}</div>
            <br/>
            <br/>
            <div id='descr'>{t('Avec LM Platinum Estates, investissez en toute confiance dans des biens titrés, vérifiés et accessibles en un clic. Vente, location, construction clé en main et gestion locative : nous vous accompagnons à chaque étape, à Yaoundé, Douala, Kribi et dans tout le Cameroun')}</div>
            <br/>
            <br/>
            <div id='services-list'>
                {values.map(x=>
                    <div id='item'>
                        <div id="block-title">
                            <div id='name'>{t(x.title)}</div>
                            <div id='icon' onClick={()=>setOpenedBlock(x.title)}>
                                <img src={opened==x.title ? "minus.svg" : "plus.svg"}                            
                                />
                            </div>
                            
                            <hr/>
                        </div>
                        {opened==x.title ? 
                        <div id ='description'>
                            {t(x.text)}
                            <br/>
                            <br/>
                            <div id='img' style={{"backgroundImage":"url(" + x.img + ")"}}>
                                {/* <img src={x.img}/> */}
                            </div>
                        </div>
                        :""
                        }
                    </div>
                )}
            <br/>
            <div onClick={props.showContactsClick}>
                <ContactUsButton />
            </div>
            <br/>
            <br/>
            <br/>
            </div>
        </div>
    </>
}